'use client'

import { useQuery } from '@tanstack/react-query'
import Image from 'next/image'
import { useTheme } from 'next-themes'
import { useState } from 'react'
import { PriceChange } from '../ui/price-change'

interface MarketOverviewBadgeProps {
  percentage?: number
  isLoading?: boolean
}

export function MarketMovementBadge({
  percentage = 0,
  isLoading = false,
}: MarketOverviewBadgeProps) {
  const [error, setError] = useState(false)
  const { theme } = useTheme()
  const { data: svg, isLoading: isSvgLoading } = useQuery({
    queryKey: ['market-cap-svg'],
    queryFn: async () => {
      const res = await fetch('/api/market-cap-svg')
      const svg = await res.text()

      return svg ? `data:image/svg+xml;base64,${btoa(svg)}` : null
    },
  })

  return (
    <div className='flex flex-row items-center justify-center gap-3 px-4 py-2 rounded-2xl border-1 border-border1 min-w-44 min-h-16'>
      {svg && !error && !isSvgLoading && (
        <Image
          src={svg || ''}
          alt='Market movement chart'
          onError={() => setError(true)}
          width={40}
          height={40}
          className={`flex-shrink-0 ${theme === 'light' ? 'brightness-0' : ''}`}
          unoptimized
        />
      )}
      {(error || isSvgLoading) && (
        <div className='size-10 flex-shrink-0 bg-border1 rounded animate-pulse' />
      )}
      <div className='flex flex-col items-start justify-center'>
        <span className='text-sm text-secondary'>Market movement</span>
        <span className='text-sm text-primary'>
          <PriceChange
            size='md'
            change={Number(percentage)}
            rightText='today'
            isLoading={isLoading}
            hideIfZero={false}
          />
        </span>
      </div>
    </div>
  )
}
